import { useEffect } from 'react';

export const useChangeDocumentTitle = (pageTitle) => {
	useEffect(() => {
		document.title = `Satish Sharma | Personal Portfolio - ${pageTitle}`;
	}, [pageTitle]);
};
